module.exports = __webpack_public_path__ + "img/energy_icon4.4b442b68.png";